import { Component } from '@angular/core';
import { AnatomyOverviewComponent } from '../components/anatomy/anatomy-overview';
import { AnatomyFeaturesComponent } from '../components/anatomy/anatomy-features';
import { AnatomyCharactersComponent } from '../components/anatomy/anatomy-characters';
import { AnatomyPlatformsComponent } from '../components/anatomy/anatomy-platforms';
import { GuestTeacherResourcesComponent } from '../components/guest-teacher-resources/guest-teacher-resources.component';

@Component({
  selector: 'stars-anatomy-page',
  templateUrl: './anatomy.html',
  styleUrls: ['./anatomy.scss'],
  imports: [
    AnatomyOverviewComponent,
    AnatomyFeaturesComponent,
    AnatomyCharactersComponent,
    AnatomyPlatformsComponent,
    GuestTeacherResourcesComponent
  ]
})
export class AnatomyPageComponent {}
